module.exports = __webpack_public_path__ + "static/media/icon-cupon-redimible.519ffd51.svg";